export default "__VITE_ASSET__xzD7xyKT__"